/**
 * Doctor dashboard queue cards: sorting, which card is open and the wait
 * colour. Pure functions so tests/unit can load them directly.
 */
import { isBlank } from "@/utils/vitalSigns";

export const SORT_OPTIONS = [
  { value: "checkinDt", text: "มาถึง" },
  { value: "start", text: "นัด" },
  { value: "checkinStatus", text: "สถานะ" },
];

export function isWaiting(row) {
  const key = row && row.aaci && row.aaci.key;
  return key === "pending" || key === "noVitals";
}

function sortValue(row, key) {
  const v = row[key];
  if (isBlank(v)) return null;
  if (key === "checkinStatus") return Number(v);
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? null : t;
}

/**
 * Returns a sorted copy. Rows without a value go last in both directions;
 * ties keep their original order.
 */
export function sortQueue(rows, key, desc) {
  return (rows || [])
    .map((row, i) => ({ row, i, v: sortValue(row, key) }))
    .sort((a, b) => {
      if (a.v === null && b.v === null) return a.i - b.i;
      if (a.v === null) return 1;
      if (b.v === null) return -1;
      if (a.v !== b.v) return desc ? b.v - a.v : a.v - b.v;
      return a.i - b.i;
    })
    .map(x => x.row);
}

/**
 * The first waiting patient in the order shown opens by itself, unless the
 * user closed it. A closed one does not hand the auto-open to the next row.
 */
export function autoExpandId(rows, dismissedIds) {
  const first = (rows || []).find(isWaiting);
  if (!first) return null;
  return (dismissedIds || []).includes(first.id) ? null : first.id;
}

export function isExpanded(id, autoId, openIds) {
  return id === autoId || (openIds || []).includes(id);
}

export function toggleExpanded(state, id, autoId) {
  const openIds = state.openIds || [];
  const dismissedIds = state.dismissedIds || [];
  if (isExpanded(id, autoId, openIds)) {
    return {
      openIds: openIds.filter(x => x !== id),
      dismissedIds: id === autoId ? [...dismissedIds, id] : dismissedIds,
    };
  }
  return {
    openIds: [...openIds, id],
    dismissedIds: dismissedIds.filter(x => x !== id),
  };
}

/** Background colour by minutes since arrival, as the old table rows had. */
export function waitVariant(checkinDt, now) {
  if (isBlank(checkinDt)) return "";
  const diff = Math.floor(
    (new Date(now).getTime() - new Date(checkinDt).getTime()) / 60000
  );
  if (diff <= 8) return "green";
  if (diff <= 15) return "lightGreen";
  if (diff <= 30) return "yellow";
  if (diff <= 40) return "lightRed";
  if (diff <= 45) return "red";
  return "purple";
}
